@if (tabs?.length) {
  <div class="map-widget" [ngClass]="{'open' : isOpen,'closed': !isOpen}">
    <div class="left-border"></div>
    <div class="content float-start">
      @for (tab of tabs; track tab) {
        <div class="content-container" [hidden]="openTab !== tab.id">
          <ng-container *ngTemplateOutlet="tab.template"></ng-container>
        </div>
      }
    </div>
    <div class="selector-container">
      @for (tab of tabs; track tab) {
        <div
          id="tab-{{tab.id}}"
          [ngClass]="{'disabled': tab.disabled }"
          class="selector d-flex"
          (click)="toggleWidget(tab)"
          placement="right"
          [ngbTooltip]="tab.tooltip">
          <i class="fal {{tab.icon}}" aria-hidden="true" [ngClass]="{'fas' : tab.isOpen}"></i>
          <i class="fal" aria-hidden="true"
          [ngClass]="{'fa-angle-double-left fas' : tab.isOpen, 'fa-angle-double-right': !tab.isOpen }"></i>
          @if (tab.counter && tab.counter > 0) {
            <div class="counter-circle">
              {{ tab.counter }}
            </div>
          }
        </div>
      }
    </div>
  </div>
}